const themes = [
  {
    name: 'Default',
    colors: {
      color1: {
        bg: '#00abff'
      },
      color2: {
        bg: '#2f3542'
      }
    }
  }
]
export default themes

export const fontFamily = {
  normal: 'LatoWeb',
  italic: 'LatoWebItalic',
  medium: 'LatoWebMedium',
  semiBold: 'LatoWebSemibold',
  bold: 'LatoWebBold'
}

export const greys = {
  dark1: '#1c1c1c',
  dark2: '#625f5f', //57606f
  dark3: '#bdbdbd', //a4b0be
  dark4: '#cccccc',
  light1: '#e6e6e6',
  light2: '#f6f6f6',
  light3: '#fafafa',
  light4: '#ffffff'
}

export const lineHeight = {
  base: '1.714rem' //24px
}

export const font = {
  size: {
    xxs: '0.786rem', //11px
    xs: '0.857rem', //12px
    sm: '0.929rem', //13px
    base: '1rem', //14px
    lg: '1.215rem', //17px
    lgxxs: '1.4285rem', //20px
    lgxs: '1.643rem', //23px
    lgsm: '1.929rem', //27px
    lgxl: '2.0715rem', //29px
    lgxxl: '2.429rem' //34px
  },
  weight: {
    base: 400,
    bold: 700,
    black: 800
  }
}

export const borderRadius = {
  sm: '3px',
  base: '6px',
  lg: '12px'
}
